// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn[data-v-9b4a5b0c]{\r\n  color: white !important;\n}\r\n\r\n", ""]);
// Exports
module.exports = exports;
